import React from 'react';
import useMissionPlanModal from '@components/operatorLobby/useMissionPlanModal';

export default function Vehicle({ token, vehicle, sendToInfrastructure, allowManualTakeover }) {

  function startTeleoperation() {
    sendToInfrastructure('infrastructure', 'assignVehicleRequest', {
      requestedVehicleId: vehicle.id
    });
  }

  const assignButton = vehicle.assignedOperator ?
    <p>{vehicle.assignedOperator}</p> :
    <button className="btn btn-outline-primary" disabled={allowManualTakeover} onClick={startTeleoperation}>Teleoperate</button>;

  const modalWindow = useMissionPlanModal({token, vehicle});

  function putInEmergencyState() {
    sendToInfrastructure(vehicle.id, 'updateVehicleStateRequest', {state: 'emergency'})
  }

  return <>
    <td>{vehicle.id}</td>
    <td>{vehicle.state}</td>
    <td>{vehicle.battery == null ? "N/A" : (parseInt(100*parseFloat(vehicle.battery)))+"%"}</td>
    <td>
      {modalWindow.component}
      <button className="btn btn-outline-primary" disabled={allowManualTakeover} onClick={modalWindow.toggle}>Edit</button>
    </td>
    <td>
      {vehicle.state !== 'emergency' && <button className="btn btn-outline-warning" onClick={putInEmergencyState}>Emergency</button>}
    </td>
    <td>
      {vehicle.state !== 'offline' && assignButton}
    </td>
  </>;
};

